(function(analytics) {
  "use strict";

  var bodyElement = document.body;
  if ( typeof(bodyElement) != "undefined" ) {
    setTimeout(function() {
      if (window.nadex.marketing.analytics.sitecatalyst.eVar61) {
        analytics.sitecatalyst.visitor.setCustomerIDs({
          "member_uuid": {
            "id": analytics.sitecatalyst.eVar61,
            "authState": Visitor.AuthState.AUTHENTICATED
          }
        });
      }
    }, 1000);
  }

})(window.nadex.marketing.analytics);
